import {
  setLocalStorageItem,
  getLocalStorageItem,
  removeLocalStorageItem,
} from "common/utils/storage/local-storage";

export const USER_KEYS = ["userId", "current_user"];

export const setUserId = (value) => {
  setLocalStorageItem(USER_KEYS[0], value);
};

export const getUserId = () => getLocalStorageItem(USER_KEYS[0]);

export const deleteUser = () => {
  // eslint-disable-next-line no-restricted-syntax
  USER_KEYS.forEach((key) => {
    removeLocalStorageItem(USER_KEYS[key]);
  });
};

export const setUser = (value) => {
  setLocalStorageItem(USER_KEYS[1], JSON.stringify(value));
};

export const getUser = () => JSON.parse(getLocalStorageItem(USER_KEYS[1]));
